var map = {
	"./avatar-01.jpg": 68757,
	"./avatar-02.jpg": 60210,
	"./avatar-03.jpg": 43350,
	"./avatar-04.jpg": 11299,
	"./avatar-05.jpg": 66722,
	"./avatar-06.jpg": 70488,
	"./avatar-07.jpg": 83537,
	"./avatar-08.jpg": 85142,
	"./avatar-09.jpg": 17438,
	"./avatar-10.jpg": 68823,
	"./avatar-11.jpg": 17154,
	"./avatar-12.jpg": 28091,
	"./avatar-13.jpg": 4073,
	"./avatar-14.jpg": 42106,
	"./avatar-15.jpg": 4760,
	"./avatar-16.jpg": 24471
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96426;